<template>
  <div id="personal-management-layer">
    <el-button type="primary" class="add-personal" size="small" @click="addPersonal">添加人员+</el-button>
    <el-table :data="personalData" size="small"
      style="width: 100%; width: 100%; box-shadow:0px 3px 8px 0px rgba(0, 0, 0, 0.08);">
      <el-table-column prop="name" label="姓名" width="200" align="center" />
      <el-table-column prop="phone" label="手机号" width="200" align="center" />
      <el-table-column label="职位" width="200" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.position }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="200" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.STATUS == '0'">正常</span>
          <span v-if="scope.row.STATUS == '1'">冻结</span>
          <span v-if="scope.row.STATUS == '2'">删除</span>
          <span v-if="scope.row.STATUS == '3'">邀请（待认领）</span>
          <span v-if="scope.row.STATUS == '4'">邀请（待确认）</span>
          <span v-if="scope.row.STATUS == '5'">拒绝加入</span>
          <span v-if="scope.row.STATUS == '6'">加入失败</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" v-if="scope.row.STATUS == '0'" @click="edit(scope.row)">修改</el-button>
          <el-button type="text" v-if="scope.row.STATUS != '0'" @click="deleteHandle(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pager-layer">
      <el-pagination :total="total" :current-page="page" style="margin-top: 8px; position: absolute; right: 8px;"
        layout="total, prev, pager, next, sizes" @size-change="sizeChange" @current-change="pageChange" />
    </div>

    <add-personal ref="add" :add="isAdd" :rowId="rowId"></add-personal>
  </div>
</template>
<script>
import addPersonal from './add-personal'
import { deletePersonalApi } from '@/api/space/personal-management'
import initData from '@/mixins/initData'
import { mapState } from 'vuex'
export default {
  components: { addPersonal },
  mixins: [initData],
  data() {
    return {
      isAdd: true,
      rowId: ''
    }
  },
  computed: {
    personalData() {
      var data = []
      if (this.data.length > 0) {
        this.data.forEach(item => {
          data.push({
            STATUS: item.STATUS,
            phone: item.phone.replace(/(\w{3})(\w+)(\w{4})/, function (x, y, z, p) {
              var i = "";
              while (i.length < z.length) { i += "*" }
              return y + i + p
            }),
            name: item.name,
            id: item.id,
            position: item.position,
            isAdmin: item.isAdmin,
            userId: item.userId
          })
        })
        return data
      }
    },
    ...mapState([
      'userInfo',
      'userContractInfo',
      'companyList',
      'currentSpace'
    ])
  },
  created() {
    // this.getContractListHandle()
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    addPersonal() {
      this.$refs.add.dialogVisible = true
      this.isAdd = true
    },
    beforeInit() {
      this.url = '/companyUser/listUser'
      this.params = { pageIndex: this.page, pageSize: this.size, companyId: this.currentSpace.companyId || '' }
      return true
    },
    edit(info) {
      this.rowId = info.id
      this.$refs.add.dialogVisible = true
      this.isAdd = false
      this.$refs.add.personalForm.name = info.name
      this.$refs.add.personalForm.phone = info.phone
      this.$refs.add.personalForm.position = info.position
    },
    deleteHandle(info) {
      this.$confirm('确定要删除吗？', '温馨提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        showClose: false
      }).then(() => {
        deletePersonalApi({
          companyId: this.currentSpace.companyId,
          id: info.id
        }).then(res => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'warning'
            });
          } else {
            this.$message({
              showClose: true,
              message: '删除成功！',
              type: 'success'
            });

            this.$nextTick(() => {
              this.init()
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {

      });

    }
  }
}
</script>
<style>
#personal-management-layer .el-table th>.cell {
  font-size: 16px;
  height: 40px;
  line-height: 40px;
}

#personal-management-layer .el-table .cell {
  font-size: 14px;
  color: #666666;
}
</style>
<style scoped>
.pager-layer {
  position: relative;
}

.add-personal {
  margin: 20px 0 10px 22px;
}
</style>
